import { type ApolloError, gql, useQuery } from '@apollo/client';
import type { Country } from '@/types/GraphqlSchema';

const QUERY = gql`
  {
    countries {
      id
      displayName
      name
      isoCode
      geom
      zoom
    }
  }
`;

type UseGetCountriesProps = {
  skip?: boolean;
};

type UseGetCountriesReturn = {
  countries: Country[];
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetCountries = ({
  skip = false,
}: UseGetCountriesProps = {}): UseGetCountriesReturn => {
  const { data, loading, error } = useQuery(QUERY, { skip });

  return {
    countries: data?.countries || [],
    loading,
    error,
  };
};
